<template>
	<div class="zbqfContainer">
		<full-page :options="options" ref="fullpage">
			<div class="section pageBox1">
				<!-- 导航 -->
				<div class="navBar">
					<img class="navLogo" src="../assets/logo2.png" alt="" @click="enterHome()">
					<ul class="navBarItem">
						<!-- <li class="busiz-active-sel">
							<router-link exact to="/" tag="a">首页</router-link>
						</li> -->
						<li>
							<router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link>
						</li>
						<el-dropdown>
							<li class="brandLi">
								<router-link exact to="/huaiBrand" style="font-size:0.9em;" tag="a">兰树品牌</router-link>
							</li>
							<el-dropdown-menu class="elDropdown" exact slot="dropdown"
								style="background:rgb(236,245,255)!important;">
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '1' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/huaiBrand" tag="a">淮树</router-link>
									</li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '2' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/brand" tag="a">心清堂</router-link>
									</li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '3' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/shuiBrand" tag="a">水姻缘</router-link>
									</li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '4' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/yiBrand" tag="a">一清堂</router-link>
									</li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li><router-link :class="brandActive == '5' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/zhongBrand" tag="a">Dr.CHUNG<span
												style="vertical-align: super;">+</span></router-link></li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '6' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/lanshuBrand" tag="a">兰树</router-link>
									</li>
								</el-dropdown-item>
								<el-dropdown-item>
									<li>
										<router-link :class="brandActive == '6' ? 'elDropdown_active' : ''"
											style="background:rgb(236,245,255) !important; color: #000 !important;"
											to="/zbqfBrand" tag="a">植本清方</router-link>
									</li>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
						<li>
							<router-link to="/brandLanshu" exact tag="a">美业菩提</router-link>
						</li>
						<li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>
						
						<li>
							<router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link>
						</li>
						
						<li>
							<router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link>
						</li>
					</ul>
				</div>
				<div class="topBgBox">
					<div class="logo">
						<img src="../assets/zbqfBrand/logo.png" alt="">
					</div>
					<div class="paragraph source-han-sans-cn-light">
						植本清方创新融合传统草本智慧与现代尖端科技，力图为东方敏感性肌肤提供一套完整的修护方案。 <br /> <br />
						我们秉承“安全、精准、高效、严谨”的原则，甄选高能活性成分，避免冗余添加，满足消费者对功效性和安全性的共同追求。
					</div>
					<div class="from fly-flower-song">——力图成为东方敏感肌首选的修护品牌</div>
				</div>
			</div>
			<div class="section pageBox2">
				<div class="newPageBoxMain2 fly-flower-song">
					<div class="newPageBoxMainLeftTxt">
						<!-- <img src="../assets/zbqfBrand/txt-2.png" alt=""> -->
						<div class="txt blod source-han-sans-cn-light">东方肌肤 易于敏感</div>
						<div class="txt">不止于表层的舒缓</div>
						<div class="txt">我们寻求根源上的修护</div>
						<br />
						<div class="txt blod source-han-sans-cn-light">以草木养生之道 探自然护肤秘方</div>
						<div class="txt">大自然的极端环境里</div>
						<div class="txt">蕴藏着惊人的修护与再生之力</div>
						<div class="txt">从东北的长白山脉 到西南的青藏高原</div>
						<div class="txt">跋涉千里 甄选万种植物精萃</div>
						<div class="txt">觅得千年岁月沉淀出的天然愈肤珍萃——“参灵草”</div>
						<br />
						<div class="txt blod source-han-sans-cn-light">以“植本之道”配“愈敏清方”</div>
						<div class="txt">融合传统草本智慧与现代尖端科技</div>
						<div class="txt">针对东方敏感肌的各种问题</div>
						<div class="txt">历经数十万次研发实验</div>
						<div class="txt">找到了肌肤愈敏天然秘钥</div>
						<div class="txt">“植本清方”</div>
						<div class="txt">为你提供安全、优效、纯净、舒韧的护肤体验</div>
					</div>
					<div class="bg-img">
						<img src="../assets/zbqfBrand/txt-2-1.png" alt="">
					</div>
				</div>
			</div>
			<div class="section pageBox3">
				<div class="goTop" @click="scrollToTop"> </div>
				<div class="newPageBoxMain3-wrap">
					<div class="newPageBoxMain3 left">
						<img src="../assets/zbqfBrand/img-3.jpg" alt="">
					</div>
					<div class="newPageBoxMain3 right">
						<div class="logo">
							<img src="../assets/zbqfBrand/logo.png" alt="">
						</div>
						<div class="title fly-flower-song">东方草本，温和而强大</div>
						<div class="txt source-han-sans-cn-light">
							植本清方 logo 以“本”为魂，其英文 “BEN” 意义非凡。它是品牌坚守修护初心的誓言，一心让肌肤回归初始自然态。<br /><br />
							同时“BEN”代表草本，寓意产品凭珍稀草木配方专利，为肌肤赋能。logo里字母“B”上的横，是重音符号，着重强调“本”之核心，尽显品牌对根本理念的执着。
						</div>
					</div>
				</div>
				<div class="bottom-img">
					<img src="../assets/zbqfBrand/txt-3.png" alt="">
				</div>
			</div>
			<div class="section pageBox4">
				<div class="goTop" @click="scrollToTop"> </div>
				<div class="newPageBoxMain4">
					<div class="newPageBoxMain4Ani">
						<div class="title fly-flower-song">东方草本实验室</div>
						<div class="tips fly-flower-song">——用草本 修护美</div>
						<div class="line"></div>
						<div class="row  source-han-sans-cn-light">
							<div class="title-row">
								<div class="little-title ">
									<span class=" fly-flower-song">敏肌专研</span>
									——融合草本+现代科技
								</div>
							</div>
							<div class="txt">汇聚顶尖专家团队，为东方敏感性肌肤提供完整修护方案</div>
						</div>
						<div class="row source-han-sans-cn-light">
							<div class="title-row">
								<div class="little-title">
									<span class=" fly-flower-song">自主研发</span>
									——创新专研定制
								</div>
							</div>
							<div class="txt">配方独立实验室，专研草本精萃修护与再生之力</div>
						</div>
						<div class="row source-han-sans-cn-light">
							<div class="title-row">
								<div class="little-title">
									<span class=" fly-flower-song">秉承原则</span>
									——安全、精准、高效、严谨
								</div>
							</div>
							<div class="txt">满足消费者对产品功效性和安全性的共同追求</div>
						</div>
						<div class="unit-logo">
							<img src="../assets/zbqfBrand/unite-logo.png" alt="">
						</div>
					</div>

					<img class="txt-img bottom" src="../assets/zbqfBrand/txt-4-1.png" alt="">
					<el-carousel class="carousel-wrap" arrow="never" height="100vh" interval="3000" :autoplay="true"
						trigger="hover" ref="cardShow">
						<el-carousel-item>
							<div class="img-cover">
								<img class="carousel-img" src="../assets/zbqfBrand/img-4-1.jpg" alt="">
							</div>
						</el-carousel-item>
						<el-carousel-item>
							<div class="img-cover">
								<img class="carousel-img" src="../assets/zbqfBrand/img-4-2.jpg" alt="">
							</div>
						</el-carousel-item>
						<el-carousel-item>
							<div class="img-cover">
								<img class="carousel-img" src="../assets/zbqfBrand/img-4-3.jpg" alt="">
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			<div class="section pageBox5">
				<div class="goTop" @click="scrollToTop"> </div>
				<div class="big-title fly-flower-song">植本清方</div>
				<div class="tips fly-flower-song">——独创东方愈敏之道</div>
				<div class="newPageBoxMain5">
					<div class="item">
						<div class="title source-han-sans-cn-light">
							<span>植</span>
							萃成分
						</div>
						<div class="txt fly-flower-song">不止配方纯净，更要有效添加</div>
					</div>
					<div class="item">
						<div class="title source-han-sans-cn-light">
							<span>本</span>
							源修护
						</div>
						<div class="txt fly-flower-song">不止表层舒缓，更要固本修护</div>
					</div>
					<div class="item">
						<div class="title source-han-sans-cn-light">
							<span>清</span>
							颜愈敏
						</div>
						<div class="txt fly-flower-song">不止安抚红敏，更要愈养焕颜</div>
					</div>
					<div class="item">
						<div class="title source-han-sans-cn-light">
							<span>方</span>
							寸重构
						</div>
						<div class="txt fly-flower-song">不止及时守护，更要长效无忧</div>
					</div>
				</div>
				<div class="bottom-img">
					<img src="../assets/zbqfBrand/txt-5.png" alt="">
				</div>
			</div>
			<div class="section pageBox6">
				<div class="goTop" @click="scrollToTop"></div>
				<div class="top-img">
					<img src="https://www.sakya.video:18101/media/1743065818.jpg" alt="">
					<img src="https://www.sakya.video:18101/media/1743065838.png" alt="">
				</div>
				<div class="newPageBoxMain6Ani">
					<div class="item fly-flower-song">
						<div class="year">2009</div>
						<div class="txt">植本清方品牌成立</div>
					</div>
					<div class="item fly-flower-song">
						<div class="year">2024</div>
						<div class="txt">植本清方舒敏系列上线</div>
					</div>
				</div>
				<div class="bottom-img">
					<img src="../assets/zbqfBrand/txt-6.png" alt="">
				</div>
			</div>
			<div class="section pageBox7">
				<el-carousel class="carousel-wrap" arrow="cover" height="100vh" interval="3000" :autoplay="true"
					ref="cardShow">
					<el-carousel-item>
						<div class="item one">
							<div class="cover">
							</div>
							<div class="info">
								<div class="title fly-flower-song">极境寻方参灵草舒敏系列</div>
								<div class="series source-han-sans-cn-medium">
									<div>洁面系列</div>
									<div class="arrow">
										<img src="../assets/zbqfBrand/arrow.png" alt="">
										<img src="../assets/zbqfBrand/arrow.png" alt="">
									</div>
								</div>
								<div class="product-wrap source-han-sans-cn-medium">
									<div class="product-item">
										<img src="../assets/zbqfBrand/pro-7-1-1.png" alt="">
										<div class="name">去油不敏感 洗卸护合一</div>
										<div class="tips">舒敏净卸多效洁颜蜜</div>
									</div>
									<div class="product-item">
										<img src="../assets/zbqfBrand/pro-7-1-2.png" alt="">
										<div class="name">无损净肤 保湿不拔干</div>
										<div class="tips">舒敏保湿洁面乳</div>
									</div>
								</div>
								<div class="bottom-img">
									<img src="../assets/zbqfBrand/txt-7.png" alt="">
								</div>
							</div>
						</div>
					</el-carousel-item>
					<el-carousel-item>
						<div class="item two">
							<div class="cover">
							</div>
							<div class="info">
								<div class="title fly-flower-song">极境寻方参灵草舒敏系列</div>
								<div class="series source-han-sans-cn-medium">
									<div>修护水乳</div>
									<div class="arrow">
										<img src="../assets/zbqfBrand/arrow.png" alt="">
										<img src="../assets/zbqfBrand/arrow.png" alt="">
									</div>
								</div>
								<div class="product-wrap source-han-sans-cn-medium">
									<div class="product-item">
										<img src="../assets/zbqfBrand/pro-7-2-1.png" alt="">
										<div class="name">沁润修护 直击干敏暗</div>
										<div class="tips">舒敏修复保湿水</div>
									</div>
									<div class="product-item">
										<img src="../assets/zbqfBrand/pro-7-2-2.png" alt="">
										<div class="name">舒缓干痒红 维稳强修护</div>
										<div class="tips">舒敏修复特护乳</div>
									</div>
								</div>
								<div class="bottom-img">
									<img src="../assets/zbqfBrand/txt-7.png" alt="">
								</div>
							</div>
						</div>
					</el-carousel-item>
					<el-carousel-item>
						<div class="item tree">
							<div class="cover">
							</div>
							<div class="info">
								<div class="title fly-flower-song">极境寻方参灵草舒敏系列</div>
								<div class="series source-han-sans-cn-medium">
									<div>修护系列</div>
									<div class="arrow">
										<img src="../assets/zbqfBrand/arrow.png" alt="">
										<img src="../assets/zbqfBrand/arrow.png" alt="">
									</div>
								</div>
								<div class="product-wrap source-han-sans-cn-medium">
									<div class="product-item">
										<img src="../assets/zbqfBrand/pro-7-3.png" alt="">
										<div class="name">速缓干痒红 四维修护屏障</div>
										<div class="tips">舒敏修复特护霜 </div>
									</div>
								</div>
								<div class="bottom-img">
									<img src="../assets/zbqfBrand/txt-7.png" alt="">
								</div>
							</div>
						</div>
					</el-carousel-item>
					<el-carousel-item>
						<div class="item four">
							<div class="cover">
							</div>
							<div class="info">
								<div class="title fly-flower-song">极境寻方参灵草舒敏系列</div>
								<div class="series source-han-sans-cn-medium">
									<div>修护系列</div>
									<div class="arrow">
										<img src="../assets/zbqfBrand/arrow.png" alt="">
										<img src="../assets/zbqfBrand/arrow.png" alt="">
									</div>
								</div>
								<div class="product-wrap source-han-sans-cn-medium">
									<div class="product-item">
										<img src="../assets/zbqfBrand/pro-7-4-1.png" alt="">
										<div class="name">速退干敏红 长效修屏障</div>
										<div class="tips">舒敏修复面膜</div>
									</div>

								</div>
								<div class="bottom-img">
									<img src="../assets/zbqfBrand/txt-7.png" alt="">
								</div>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="section pageBox8">
				<div class="goTop" @click="scrollToTop"> </div>
				<div class="newPageBoxMain8">
					<div class="img-wrap">
						<img src="../assets/zbqfBrand/xiaohongshu.png" alt="">
						<img src="../assets/zbqfBrand/douyin.png" alt="">
					</div>
					<div class="txt-wrap source-han-sans-cn-light">
						<div>邮箱：postermaster@lasur.com</div>
						<div>电话：0571-89025888 </div>
						<div>地址：浙江省杭州市之江东路越秀·维多利中心A座17楼</div>
					</div>
				</div>
				<div class="bottom-info source-han-sans-cn-medium">
					<span>Copyright © 2023 兰树化妆品股份有限公司</span>
					<span>浙ICP备20018890号-1 </span>
					<span> 浙公网安备 33052102000740号</span>
				</div>
			</div>
		</full-page>
	</div>
</template>

<script>
export default {
	data() {
		return {
			circleItemBox: [
				"circleItemBox0",
				"circleItemBox1",
				"circleItemBox2",
				"circleItemBox3",
				"circleItemBox4",
				"circleItemBox5",
				"circleItemBox6"
			],
			chooseIndex: 0,
			timePosition: [-6.96, -5.42, -3.9, -2.35, -0.79, 0.74, 2.27, 3.82, 5.37, 6.93],
			options: {
				licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
				//是否显示导航，默认为false
				navigation: true,
			},
			brandActive: 1,
			circleData: [
				{
					id: 1,
					year: '2010',
					content: '淮树品牌上线*'
				},
				{
					id: 2,
					year: '2014',
					content: '创新品质,推出私人订制修护产品。'
				},
				{
					id: 3,
					year: '2015',
					content: '推出原生赋活套，费者喜欢。'
				},
				{
					id: 4,
					year: '2016',
					content: '创立美业菩提节并于8月8日在上海成功举办。'
				},
				{
					id: 5,
					year: '2017',
					content: '举办第二届美业菩提节，参会人数近4000人，再次掀起美业新高潮。'
				},
				{
					id: 6,
					year: '2018',
					content: '兰树落户湖州市德清国家级高新区,用地约 85 亩,总投资人民币 5.5 亿元。'
				},
				{
					id: 7,
					year: '2021',
					content: '淮树品牌全面年轻化升级上线*'
				}
			],

		}
	},
	mounted() {
		// console.log('start', this.$refs.bannerHeight);
		this.imgLoad();
		window.addEventListener('resize', () => {
			// this.bannerHeight = this.$refs.bannerHeight[0].height;
			this.imgLoad();
		}, false)
	},
	methods: {
		scrollToTop() {
			fullpage_api.moveTo(1);

		},
		enterProducts(id) {
			this.$router.push({ path: '/productsList', query: { brandId: id } });
		},
		enterHome() {
			this.$router.push({ path: '/' });
		},
		imgLoad() {
			// console.log('brandId', this.brandId);
			this.$nextTick(() => {
				// this.bannerHeight = this.$refs.bannerHeight[0].height;
				// console.log(this.$refs.bannerHeight[0].height);
			})

		}
	}

}
</script>

<style scoped>
@import "../../static/css/font.css";
.goTop {
	width: 2.6vw;
	height: 5.38vh;
	background: url(../assets/newLasur/goTop.png) no-repeat;
	background-position: 50% 50%;
	background-size: 100%;
	overflow: hidden;
	position: absolute;
	right: 3.8vw;
	bottom: 9.25vh;
	cursor: pointer;
	z-index: 999;
}

.goTop:hover {
	background: url(../assets/newLasur/goTop2.png) no-repeat;
	background-position: 50% 50%;
	background-size: 100%;
	overflow: hidden;
}

.zbqfContainer {
	margin: 0;
	padding: 0;
	position: relative;
}


/* 导航 */

/* 下拉菜单栏 选中 */
.elDropdown_active {
	background-color: #FFFFFF !important;
	color: #000000 !important;
}

.navBar {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: absolute;
	justify-content: space-between;
	top: 0;
	background: #FFFFFF;
	/* border-bottom:1px solid rgba(255,255,255,0.2); */
	z-index: 999;
}


.navLogo {
	width: 10%;
	margin-left: 5vw;
	cursor: pointer;
}

.navBarItem {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
}



.navBarItem li {
	list-style: none;
	float: left;
}

.brandLi a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.6em !important;
	padding-bottom: 1.6em !important;
	padding-left: 2em;
	padding-right: 2em;
}

.navBarItem li a {
	text-decoration: none;
	font-size: 0.875em;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #222222;
	line-height: 20px;
	padding-top: 1.4em;
	padding-bottom: 1.4em;
	padding-left: 1.4rem;
	padding-right: 1.4rem;
}


.elDropdown a {
	color: #111111;
	text-decoration: none;
}

.el-dropdown {
	vertical-align: top;
}

.el-dropdown+.el-dropdown {
	margin-left: .9375vw;
}

.el-icon-arrow-down {
	font-size: 0.8vw;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-icon-arrow-down {
	font-size: 0.8vw;
}

/* pageBox1 */
.pageBox1 {
	background-color: #F0F4ED;
	width: 100%;
	background: url(https://www.sakya.video:18101/media/1742955952.jpg) no-repeat;
	background-position: top left;
	background-size: cover;
	display: flex;
	flex-direction: column;
}

.topBgBox {
	width: 28%;
	top: 10.5%;
	left: 0%;
	opacity: 0.5;
	position: relative;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	animation: topbgbox 1.5s;
	-webkit-animation: topbgbox 1.5s;
	min-width: 31vw;
}

.topBgBox .logo {
	margin-top: 3vh;
}

.topBgBox .logo img {
	width: 9vw;
}

.topBgBox .paragraph {
	color: #444;
	font-weight: lighter;
	line-height: 2vw;;
	letter-spacing: 1px;
	margin-top: 5vh;
	text-align: justify;
	font-size: 1vw;
}

.topBgBox .from {
	font-size: 1.1vw;
	color: #040000;
	text-align: right;
	margin-top: 5vh;
	font-weight: 400;
}


.topBgBoxImg {
	width: 100%;
}

.pageBox1.active .topBgBox {
	left: 10%;
	opacity: 1;
}

/* 动画 topbgbox */
/* first 图1动画 */
@keyframes topbgbox {
	from {
		opacity: 0;
		left: 0;
	}

	to {
		opacity: 1;
		/* right:30%;} */
		left: 10%;
	}
}

@-webkit-keyframes topbgbox

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		left: 0;
	}

	to {
		opacity: 1;
		left: 10%;
	}

	/* right:30%;} */
}

/* pageBox2 */
.pageBox2 {
	width: 100%;
	background-color: #F0F4ED;
	/* background: url(../assets/huaiBrand/newBg2.jpg) no-repeat; */
	background: url(https://www.sakya.video:18101/media/1742971265.jpg) no-repeat;
	background-position: 50% 50%;
	background-size: cover;
}


.newPageBoxMain2 {
	width: 90%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.newPageBoxMain2 .newPageBoxMainLeftTxt img {
	width: 21.25vw;
}

.newPageBoxMain2 .newPageBoxMainLeftTxt {
	letter-spacing: 2px;
	padding-top: 11vh;
	position: relative;
	left: 6.25vw;
	opacity: 0;
	bottom: -25vh;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	animation: newPageBoxMainLeftTxt 1.5s;
	-webkit-animation: newPageBoxMainLeftTxt 1.5s;
}

.newPageBoxMain2 .newPageBoxMainLeftTxt .txt {
	font-size: 1vw;
	color: #555;
	margin-bottom: 1.2vh;
}

.newPageBoxMain2 .newPageBoxMainLeftTxt .txt.blod {
	color: #040000;
	font-weight: 500;

}

.newPageBoxMain2 .bg-img img {
	width: 31.25vw;
	margin-top: 4vh;
	margin-left: 6.25vw;
}

.pageBox2.active .newPageBoxMainLeftTxt {
	bottom: 4vh;
	opacity: 1;
}

@keyframes newPageBoxMainLeftTxt {
	from {
		opacity: 0;
		bottom: -25vh;
	}

	to {
		opacity: 1;
		bottom: 4vh;
	}
}



@-webkit-keyframes newPageBoxMainLeftTxt

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		bottom: -25vh;
	}

	to {
		opacity: 1;
		bottom: 4vh;
	}
}
/* pageBox3 */

.pageBox3 {
	width: 100%;
	background-color: #F0F4ED;
	position: relative;
}

.newPageBoxMain3-wrap {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 76%;
	margin-left: 12%;
	border-top: 1px solid #dcdcdc;
	height: 80vh;
}

.newPageBoxMain3 {
	position: relative;
}

.newPageBoxMain3.left {
	display: flex;
	align-items: center;
	left: -8%;
	opacity: 0;
	width: 54%;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	animation: newPageBoxMain3Left 1.5s;
	-webkit-animation: newPageBoxMain3Left 1.5s;
}

.pageBox3.active .left {
	left: 0%;
	opacity: 1;
}

.newPageBoxMain3.left img {
	width: 96%;
	user-select: none;
}

.newPageBoxMain3.right {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	right: -8%;
	opacity: 0;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	animation: newPageBoxMain3Right 1.5s;
	-webkit-animation: newPageBoxMain3Right 1.5s;
	width: 44%;
	margin-left: 1%;
}

.newPageBoxMain3.right .logo {
	margin-bottom: 3.125vh;
}

.newPageBoxMain3.right .logo img {
	width: 8vw;
}

.newPageBoxMain3.right .title {
	font-size: 2.3vw;
	margin-bottom: 5vh;
	font-weight: lighter;
}

.newPageBoxMain3.right .txt {
	max-width: 31.25vw;
	text-align: justify;
	color: #444;
	letter-spacing: 1px;
	line-height: 2vw;
	font-weight: lighter;
	font-size: 1.1vw;
}


.pageBox3.active .right {
	opacity: 1;
	right: 2%;
}

.pageBox3 .bottom-img {
	width: 76%;
	margin-left: 12%;
}

.pageBox3 .bottom-img img {
	width: 100%;
}

@keyframes newPageBoxMain3Left {
	from {
		opacity: 0;
		left: -8%;
	}

	to {
		opacity: 1;
		left: 0%;
	}
}



@-webkit-keyframes newPageBoxMain3Left

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		left: -8%;
	}

	to {
		opacity: 1;
		left: 0%;
	}
}

@keyframes newPageBoxMain3Right {
	from {
		opacity: 0;
		right: -8%;
	}

	to {
		opacity: 1;
		right: 2%;
	}
}



@-webkit-keyframes newPageBoxMain3Right

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		right: -8%;
	}

	to {
		opacity: 1;
		right: 2%;
	}
}





/* pageBox4 */

.pageBox4 {
	width: 100%;
	background-color: #F0F4ED;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.newPageBoxMain4 {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex-wrap: nowrap;
	position: relative;
}


.newPageBoxMain4 .txt-img.bottom {
	width: 27.5vw;
	margin-top: 5vh;
	margin-left: 13.5%;
}

.newPageBoxMain4 .carousel-wrap {
	position: absolute;
	right: 0;
	top: 0;
	z-index: 100;
	width: 50%;
}

.pageBox4 .img-cover {
	width: 50vw;
	height: 100vh;
}

.newPageBoxMain4 .carousel-img {
	object-fit: cover;
	width: 50vw;
	height: 100vh;
}

.newPageBoxMain4Ani {
	position: relative;
	opacity: 0;
	left: 0%;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	animation: newPageBoxMain4Ani 1.5s;
	-webkit-animation: newPageBoxMain4Ani 1.5s;
}

.newPageBoxMain4Ani .title {
	margin-top: 9vh;
	font-size: 2.55vw;
	color: #333;
	font-weight: lighter;
	margin-left: .75vw;
}

.newPageBoxMain4Ani .tips {
	font-size: 1.3vw;
	margin-bottom: 5vh;
	color: #444;
	margin-left: .75vw;
	margin-top: 1.5vh;
	letter-spacing: 1px;
}

.newPageBoxMain4Ani .line {
	height: 1px;
	background-color: #C0C3BE;
	width: 27.5vw;
	margin-bottom: 5vh;
}

.newPageBoxMain4Ani .row {
	margin-left: .75vw;
	margin-bottom: 6vh;
}

.newPageBoxMain4Ani .title-row {
	color: #444;
}

.newPageBoxMain4Ani .title-row .little-title {
	font-size: 1.125vw;
	margin-bottom: 1.5vh;
	color: #555;
}

.newPageBoxMain4Ani .title-row .little-title span {
	font-size: 1.5vw;
}

.newPageBoxMain4Ani .txt {
	font-size: 1vw;
	color: #444;
	font-weight: lighter;
	letter-spacing: 1px;
}

.pageBox4 .unit-logo img {
	width: 24.75vw;
	height: 2.375vw;
}

.pageBox4.active .newPageBoxMain4Ani {
	left: 13%;
	opacity: 1;
}

@keyframes newPageBoxMain4Ani {
	from {
		opacity: 0;
		left: 0%;
	}

	to {
		opacity: 1;
		left: 13%;
	}
}



@-webkit-keyframes newPageBoxMain4Ani

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		left: 0%;
	}

	to {
		opacity: 1;
		left: 13%;
	}
}



/* pageBox5 */

.pageBox5 {
	width: 100%;
	background: url(https://www.sakya.video:18101/media/1743062268.jpg) no-repeat;
	background-color: #F0F4ED;
	background-position: 50% 50%;
	background-size: cover;
}

.pageBox5 .big-title {
	margin-left: 12%;
	font-size: 2.5vw;
	color: #333;
	font-weight: lighter;
	margin-top: 6vh;
	letter-spacing: 1px;
}

.pageBox5 .tips {
	margin-left: 12%;
	font-size: 1.25vw;
	margin-bottom: 2.5vh;
	margin-top: 0.8vh;
	color: #444;
	letter-spacing: 2px;
}

.pageBox5 .newPageBoxMain5 {
	width: 34.125vw;
	height: 21.5vw;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	justify-content: space-between;
	margin-left: 0%;
	opacity: 0;
	padding-bottom: 10%;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	animation: newPageBoxMain5Ani 1.5s;
	-webkit-animation: newPageBoxMain5Ani 1.5s;
}

.pageBox5 .newPageBoxMain5 .item {
	width: 13.125vw;
	height: 6.5vw;
	background-color: rgba(255, 255, 255, .6);
	padding: 1.75vw;
}

.pageBox5 .newPageBoxMain5 .item .title {
	border-bottom: 1px solid #535353;
	font-size: 1.125vw;
	padding-bottom: .25vw;
	color: #1C1C1C;
}

.pageBox5 .newPageBoxMain5 .item .title span {
	color: #506938;
	font-size: 2.25vw;
}

.pageBox5 .newPageBoxMain5 .item .txt {
	font-size: .9375vw;
	color: #444;
	font-weight: lighter;
	margin-top: .625vw;
}

.pageBox5 .bottom-img {
	position: absolute;
	left: 12%;
	bottom: 2%;
}

.pageBox5 .bottom-img img {
	width: 41.25vw;
}

.pageBox5.active .newPageBoxMain5 {
	margin-left: 12%;
	opacity: 1;
}

@keyframes newPageBoxMain5Ani {
	from {
		opacity: 0;
		margin-left: 0%;
	}

	to {
		opacity: 1;
		margin-left: 13%;
	}
}



@-webkit-keyframes newPageBoxMain5Ani

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		margin-left: 0%;
	}

	to {
		opacity: 1;
		margin-left: 13%;
	}
}

.pageBox6 {
	background-color: #F0F4ED;
}

.pageBox6 .top-img {
	width: 80%;
	margin-left: 10%;
}

.pageBox6 .top-img img {
	width: 100%;
	margin-bottom: 3.5vh;
}

.pageBox6 .newPageBoxMain6Ani {
	position: relative;
}

.pageBox6 .newPageBoxMain6Ani .item {
	position: absolute;
	width: 15vw;
}

.pageBox6 .newPageBoxMain6Ani .item:first-child {
	left: 13%;
	opacity: 0;
	top: 30vh;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	animation: newPageBoxMain6LeftAni 1.5s;
	-webkit-animation: newPageBoxMain6LeftAni 1.5s;
}

.pageBox6 .newPageBoxMain6Ani .item:last-child {
	right: 13%;
	opacity: 0;
	top: -30vh;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	animation: newPageBoxMain6RightAni 1.5s;
	-webkit-animation: newPageBoxMain6RightAni 1.5s;
}

.pageBox6 .newPageBoxMain6Ani .item .year {
	font-size: 2.5vw;
	color: #070707;
}

.pageBox6 .newPageBoxMain6Ani .item .year::before {
	content: '';
	display: inline-block;
	width: 1px;
	height: 1.75vw;
	background: #ccc;
	position: absolute;
	left: -0.75vw;
	top: 2vh;
}

.pageBox6 .newPageBoxMain6Ani .item .txt {
	margin-top:1vh;
	font-size: 1.25vw;
}

.pageBox6 .bottom-img {
	width: 80%;
	margin-left: 10%;
}

.pageBox6 .bottom-img img {
	width: 100%;
	margin-top: 22vh;
}

.pageBox6.active .newPageBoxMain6Ani .item:first-child {
	top: 0%;
	opacity: 1;
}

.pageBox6.active .newPageBoxMain6Ani .item:last-child {
	top: 0%;
	opacity: 1;
}

@keyframes newPageBoxMain6LeftAni {
	from {
		opacity: 0;
		top: 18vh;
	}

	to {
		opacity: 1;
		top: 0;
	}
}



@-webkit-keyframes newPageBoxMain6LeftAni

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		top: 18vh;
	}

	to {
		opacity: 1;
		top: 0;
	}
}

@keyframes newPageBoxMain6RightAni {
	from {
		opacity: 0;
		top: -18vh;
	}

	to {
		opacity: 1;
		top: 0;
	}
}



@-webkit-keyframes newPageBoxMain6RightAni

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		top: -18vh;
	}

	to {
		opacity: 1;
		top: 0;
	}
}

.pageBox7 {
	background-color: #F0F4ED;
}

.pageBox7 .carousel-wrap {
	width: 96%;
}

.pageBox7 .carousel-wrap .item {
	display: flex;
}

.pageBox7 .carousel-wrap .item.one .cover {
	flex: 1;
	height: 100vh;
	background-image: url(https://www.sakya.video:18101/media/1743133705.jpg);
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-size: cover;
}

.pageBox7 .carousel-wrap .item.two .cover {
	flex: 1;
	height: 100vh;
	background-image: url(https://www.sakya.video:18101/media/1743133709.jpg);
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-size: cover;
}

.pageBox7 .carousel-wrap .item.tree .cover {
	flex: 1;
	height: 100vh;
	background-image: url(https://www.sakya.video:18101/media/1743133713.jpg);
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-size: cover;
}

.pageBox7 .carousel-wrap .item.four .cover {
	flex: 1;
	overflow: hidden;
	height: 100vh;
	background-image: url(https://www.sakya.video:18101/media/1743133717.jpg);
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-size: cover;
}

.pageBox7 .carousel-wrap .item .cover img {
	width: 100%;
}

.pageBox7 .carousel-wrap .item .info {
	flex: 0.8;
	padding-left: 6.25vw;
	margin-top: 5vh;
	box-sizing: border-box;
	position: relative;

}

.pageBox7 .carousel-wrap .item .info .title {
	font-size: 2vw;
	border-bottom: 1px solid #dcdcdc;
	padding-bottom: 1.2vh;
	color: #333;
}

.pageBox7 .carousel-wrap .item .info .series {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 1.625vw;
	margin-top: 1.2vh;
	color: #040000;
}

.pageBox7 .carousel-wrap .item .info .series img {
	width: .5vw;
	height: 1.5vw;
	display: block;
}

.pageBox7 .carousel-wrap .item .info .series .arrow {
	display: flex;
	align-items: center;
}

.pageBox7 .carousel-wrap .item .info .product-wrap {
	display: flex;
	align-items: center;
	justify-content: space-around;
	margin-top: 12vh;
	text-align: center;
}

.pageBox7 .carousel-wrap .item .info .product-wrap img {
	width: 17.5vw;
	margin-top: 5vh;
}

.pageBox7 .carousel-wrap .item .info .product-wrap .name {
	font-size: 1.125vw;
	margin-top: 1.2vh;
}

.pageBox7 .carousel-wrap .item .info .product-wrap .tips {
	font-size: .875vw;
	color: #999;
	margin-top: 0.5vh;
	letter-spacing: 1px;
	font-weight: lighter;
}

.pageBox7 .carousel-wrap .item .info .bottom-img {
	position: absolute;
	bottom: 2vh;
	width: 80%;
}

.pageBox7 .carousel-wrap .item .info .bottom-img img {
	width: 100%;
}

/* pageBox8 */
.pageBox8 {
	width: 100%;
	background-color: #F0F4ED;
	background: url(https://www.sakya.video:18101/media/1743128592.jpg) no-repeat;
	background-position: 50% 100%;
	background-size: cover;
}

.pageBox8 .img-wrap {
	display: flex;
	align-items: flex-end;
	margin-left: 12%;
}

.pageBox8 .img-wrap img:first-child {
	width: 8vw;
	display: block;
	margin-right: 3.75vw;
}

.pageBox8 .img-wrap img:last-child {
	width: 7.75vw;
	display: block;
}

.pageBox8 .txt-wrap {
	font-size: .9375vw;
	color: #444;
	margin-left: 12%;
	margin-bottom: 18.75vw;
	margin-top: 3.125vw;
	letter-spacing: 1px;
	line-height: 1.75vw;
	font-weight: lighter;
}

.pageBox8 .bottom-info {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	height: 4vw;
	line-height: 4vw;
	text-align: center;
	font-size: .875vw;
	color: #fff;
}

.pageBox8 .bottom-info span {
	margin: 0 10px;
}

.pageBox8 .newPageBoxMain8 {
	position: relative;
	bottom: -6.25vw;
	opacity: 0;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
	animation: newPageBoxMain6LeftAni 1.5s;
	-webkit-animation: newPageBoxMain6LeftAni 1.5s;
}

.pageBox8.active .newPageBoxMain8 {
	opacity: 1;
	bottom: 0;
}

@keyframes newPageBoxMain8Ani {
	from {
		opacity: 0;
		bottom: -6.25vw;
	}

	to {
		opacity: 1;
		bottom: 0;
	}
}



@-webkit-keyframes newPageBoxMain8Ani

/* Safari 和 Chrome */
	{
	from {
		opacity: 0;
		bottom: -6.25vw;
	}

	to {
		opacity: 1;
		bottom: 0;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/zbqfBrand.vue